import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        width: '100%'
    },
    accordionSummary: {
        flexDirection: 'row-reverse',
        alignItems: 'flex-start',
        marginLeft: '-10px'
    },
    accordionDetails:{
        paddingLeft:'50px',
    },
    expanded: {minHeight: '0 !important'},
    content: {
        margin: '16px 10px',
        '&$expanded': {
            margin: '16px 10px'
        },
    },
    expandIcon: {
        transform: 'rotate(270deg)',
        '&$expanded': {
            transform: 'rotate(0deg)',
        },
    },
    statusContent: {
        paddingTop: '0',
        paddingLeft: '3rem',
        maxHeight: '250px',
        overflowY: "auto"
    }
}));

